import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { deleteAction, getAction } from '@/api/manage';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import SysCategoryModal from "./modules/SysCategoryModal";
import { getBindingValue, getLargePermission } from '@/utils/hasPermission';
export default {
  name: "SysCategoryList",
  mixins: [JeecgListMixin],
  components: {
    SysCategoryModal: SysCategoryModal
  },
  data: function data() {
    return {
      root: 0,
      description: '分类字典管理页面',
      // 表头
      columns: [{
        title: '类型名称',
        align: "left",
        dataIndex: 'name'
      }, {
        title: '类型编码',
        align: "center",
        dataIndex: 'code'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        list: "/sys/category/rootList",
        childList: "/sys/category/childList",
        delete: "/sys/category/delete",
        deleteBatch: "/sys/category/deleteBatch",
        exportXlsUrl: "/sys/category/exportXls",
        importExcelUrl: "sys/category/importExcel"
      },
      expandedRowKeys: [],
      hasChildrenField: "hasChild",
      pidField: "pid",
      dictOptions: {},
      dataSource: []
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    },
    tableProps: function tableProps() {
      var _this = this;

      return {
        // 列表项是否可选择
        rowSelection: {
          selectedRowKeys: _this.selectedRowKeys,
          onChange: function onChange(selectedRowKeys) {
            return _this.selectedRowKeys = selectedRowKeys;
          }
        }
      };
    }
  },
  watch: {
    $route: function $route(to, form) {
      this.autoLoadInit = false;

      if (to.path !== form.path) {
        this.dataSource = [];
        this.loadData();
      }
    }
  },
  methods: {
    loadData: function loadData(arg) {
      var _this2 = this;

      if (arg == 1) {
        this.ipagination.current = 1;
      }

      this.loading = true;
      var ss = this.$route.path.split("/");
      this.root = ss[ss.length - 1];
      this.expandedRowKeys = [];
      this.getFormDataById(this.root, this.dataSource);
      var row = this.parentFormData;
      this.expandedRowKeys.push(this.root);
      var params = this.getQueryParams(); //查询条件

      params[this.pidField] = this.root;
      getAction(this.url.childList, params).then(function (res) {
        if (res.success) {
          if (res.result && res.result.length > 0) {
            _this2.dataSource = _this2.getDataByResult(res.result);
          } else {
            _this2.dataSource = [];
          }

          _this2.loading = false;
        }
      });
      /*return new Promise((resolve, reject) => {
        this.getFormDataById(this.root, this.dataSource)
        let row = this.parentFormData
        this.expandedRowKeys.push(this.root)
        let params = this.getQueryParams();//查询条件
        params[this.pidField] = this.root
        getAction(this.url.childList, params).then((res) => {
          console.log("11111", res)
          if (res.success) {
            if (res.result && res.result.length > 0) {
              debugger;
              this.dataSource = this.getDataByResult(res.result)
              console.log(this.dataSource)
              // this.dataSource = [...this.dataSource]
              resolve()
            } else {
              reject()
            }
          } else {
            reject()
          }
        })
        this.loading = false
      })*/
      // let params = this.getQueryParams()
      // let ss = this.$route.path.split("/");
      // this.root = ss[ss.length - 1];
      // console.log(this.root)
      // params.id = this.root;
      // return new Promise((resolve) => {
      // getAction(this.url.list, params).then(res => {
      //     if (res.success) {
      //         let result = res.result
      //         if (Number(result.total) > 0) {
      //             this.ipagination.total = Number(result.total)
      //             this.dataSource = this.getDataByResult(res.result.records)
      //             resolve()
      //         } else {
      //             this.ipagination.total = 0
      //             this.dataSource = []
      //         }
      //     } else {
      //         this.$notification.warning({ message: res.message })
      //     }
      //     this.loading = false
      // })
      // })
    },
    getDataByResult: function getDataByResult(result) {
      var _this3 = this;

      result.forEach(function (item) {
        //判断是否标记了带有子节点
        if (item[_this3.hasChildrenField] == '1') {
          var loadChild = {
            id: item.id + '_loadChild',
            name: 'loading...',
            isLoading: true
          };
          item.children = [loadChild];
        }
      });
      return result;
    },
    handleExpand: function handleExpand(expanded, record) {
      var _this4 = this;

      // 判断是否是展开状态
      if (expanded) {
        this.expandedRowKeys.push(record.id);

        if (record.children.length > 0 && record.children[0].isLoading === true) {
          var params = this.getQueryParams(); //查询条件

          params[this.pidField] = record.id;
          getAction(this.url.childList, params).then(function (res) {
            if (res.success) {
              if (res.result && res.result.length > 0) {
                record.children = _this4.getDataByResult(res.result);
                _this4.dataSource = _toConsumableArray(_this4.dataSource);
              } else {
                record.children = '';
                record.hasChildrenField = '0';
              }
            } else {
              _this4.$notification.warning({
                message: res.message
              });
            }
          });
        }
      } else {
        var keyIndex = this.expandedRowKeys.indexOf(record.id);

        if (keyIndex >= 0) {
          this.expandedRowKeys.splice(keyIndex, 1);
        }
      }
    },
    initDictConfig: function initDictConfig() {},
    modalFormOk: function modalFormOk(formData, arr) {
      if (!formData.id) {
        this.addOk(formData, arr);
      } else {
        this.editOk(formData, this.dataSource);
        this.dataSource = _toConsumableArray(this.dataSource);
      }
    },
    editOk: function editOk(formData, arr) {
      if (arr && arr.length > 0) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].id == formData.id) {
            arr[i] = formData;
            break;
          } else {
            this.editOk(formData, arr[i].children);
          }
        }
      }
    },
    addOk: function () {
      var _addOk = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData, arr) {
        var _iterator, _step, i;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (formData[this.pidField]) {
                  _context.next = 4;
                  break;
                }

                this.loadData();
                _context.next = 23;
                break;

              case 4:
                this.expandedRowKeys = [];
                console.log("22222", arr);
                _iterator = _createForOfIteratorHelper(arr);
                _context.prev = 7;

                _iterator.s();

              case 9:
                if ((_step = _iterator.n()).done) {
                  _context.next = 15;
                  break;
                }

                i = _step.value;
                _context.next = 13;
                return this.expandTreeNode(i);

              case 13:
                _context.next = 9;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](7);

                _iterator.e(_context.t0);

              case 20:
                _context.prev = 20;

                _iterator.f();

                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 17, 20, 23]]);
      }));

      function addOk(_x, _x2) {
        return _addOk.apply(this, arguments);
      }

      return addOk;
    }(),
    expandTreeNode: function expandTreeNode(nodeId) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.getFormDataById(nodeId, _this5.dataSource);

        var row = _this5.parentFormData;

        _this5.expandedRowKeys.push(nodeId);

        var params = _this5.getQueryParams(); //查询条件


        params[_this5.pidField] = nodeId;
        getAction(_this5.url.childList, params).then(function (res) {
          console.log("11111", res);

          if (res.success) {
            if (res.result && res.result.length > 0) {
              if (typeof row != 'undefined') {
                row.children = _this5.getDataByResult(res.result);
              }

              _this5.dataSource = _toConsumableArray(_this5.dataSource);

              _this5.loadData();

              resolve();
            } else {
              reject();
            }
          } else {
            reject();
          }
        });
      });
    },
    getFormDataById: function getFormDataById(id, arr) {
      if (arr && arr.length > 0) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].id == id) {
            this.parentFormData = arr[i];
          } else {
            this.getFormDataById(id, arr[i].children);
          }
        }
      }
    }
  }
};